export default __webpack_public_path__ + "static/blob6-b37944022ba6f1ad1fe451b333c09925.svg";